import React from 'react';
import { Button } from 'antd';
import pdfImage from '../../../assets/pdf.png';

import {
    ExemptionDocument,
    OrderFormDocument,
    ShippingLabelDocument,
    LaceyActDocument,
} from '../../../assets/pdfs';

const data = [ExemptionDocument, OrderFormDocument, ShippingLabelDocument, LaceyActDocument];

export default function Form() {
    let rowCounter = 0;
    return (
        <>
            <h1 className="double">Forms</h1>
            <div className="pdf-form-container">
                {data.map(e => (
                    <div key={(rowCounter += 1)}>
                        <hr />
                        <div className="pdf-form">
                            <a href={e.file} rel="noopener noreferrer" target="_blank">
                                <img src={pdfImage} alt="pdf-icon" />
                            </a>
                            <div className="pdf-form-text">
                                <span className="pdf-title">{e.name}</span>
                                <span className="pdf-size">{e.size}MB</span>
                            </div>

                            <Button
                                className="pdf-form-btn"
                                type="secondary"
                                href={e.file}
                                target="_blank"
                            >
                                Download
                            </Button>
                        </div>
                    </div>
                ))}
                <hr />
            </div>
        </>
    );
}
